import { Channels } from '@/core/constants/channelConstants';
import { Roles } from '@/core/constants/roleConstants';
import { BasePolicy } from '../BasePolicy';

export class PlannerPolicy extends BasePolicy {
  static canList() {
    const roles = [
      Roles.SELLER,
      Roles.SUB_MANAGER,
      Roles.MANAGER,
      Roles.REGIONAL_MANAGER,
      Roles.SUB_DIRECTOR,
      Roles.DIRECTOR,
    ];

    const channels = [Channels.WHOLESALER, Channels.RETAIL];

    return this.hasAnyRole(roles) && this.hasAnyChannel(channels);
  }
}
